import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

// @ts-ignore
const emailOnLoad = window.EMAIL || '';

interface State {
    username: string;
    password: string;
}

const initialState: State = {
    username: emailOnLoad,
    password: '',
};

const slice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        updateUsername: (state: State, { payload: username }: PayloadAction<string>) => {
            state.username = username;
        },
        updatePassword: (state: State, { payload: password }: PayloadAction<string>) => {
            state.password = password;
        },
    },
});

const getState = (state: RootState) => state[slice.name];
export const getUsername = (rootState: RootState) => {
    const state = getState(rootState);
    return state.username || '';
};
export const getPassword = (rootState: RootState) => {
    const state = getState(rootState);
    return state.password || '';
};

export const { updateUsername, updatePassword } = slice.actions;
export default slice;
